import { ITeamSkillMast } from "../../models/ISkillTeamManagement";
import { ITeamManagement } from "../../models/TeamManagement";

export interface teamData {
    branch?: string,
    branch_ID?: number,
    company?: string,
    company_ID?: number,
    team_ID?: number,
    team_Manager?: string,
    team_Manager_ID?: number,
    team_Name?: string
}

export const EmptyTeam: ITeamSkillMast = {
    team_Name: "",
    status: true,
    user_Added_by: null,
    createdOn: null,
    teamManagerid: null,
    company_ID: null,
    team_Status: true,
    branch_ID: null,
    skillCategories: null,
    allocate_Users: null,
}

export const TeamData: teamData = {
    branch: "",
    branch_ID: 0,
    company: "",
    company_ID: 0,
    team_ID: 0,
    team_Manager: "",
    team_Manager_ID: 0,
    team_Name: "",
}